import clsx from 'clsx'
import { css } from '@emotion/css'

const MonthGrid = ({ selected, onSelect, isRange }) => {
  let start
  let end
  if (Array.isArray(selected)) {
    if (selected.length) {
      ;[start = -1, end = 12] = selected
    }
  } else {
    start = selected
    end = selected
  }
  return (
    <div className="grid grid-cols-4 gap-y-2 my-4 text-sm flex-1">
      {Array.from({ length: 12 }).map((_, i) => {
        const isSelect = start === i || end === i
        const isLeft = (i + 1) % 4 === 1
        const isRight = (i + 1) % 4 === 0
        return (
          <div className="flex items-center justify-center relative" key={i}>
            <div
              className={clsx(
                'absolute w-1/2 h-full left-0',
                isLeft && 'hidden',
                i > start && i <= end && 'bg-primary-100'
              )}
            />
            <div
              className={clsx(
                'absolute w-1/2 h-full right-0',
                isRight && 'hidden',
                i >= start && i < end && 'bg-primary-100'
              )}
            />
            <div
              onClick={() => {
                if (onSelect) onSelect(i)
              }}
              className={clsx(
                'w-10 h-10 flex items-center justify-center cursor-pointer relative',
                !isSelect && 'hover:bg-primary-100',
                !isSelect &&
                  i > start &&
                  i < end &&
                  'bg-primary-100 text-primary-700',
                isSelect &&
                  (isRange ? 'text-white bg-primary-700' : 'text-primary-700'),
                css`
                  border-radius: 50%;
                `
              )}
            >
              <span>{i + 1}月</span>
              {isSelect && !isRange && (
                <div
                  className={clsx(
                    'bg-primary-700 absolute bottom-0',
                    css`
                      width: 6px;
                      height: 6px;
                      border-radius: 50%;
                    `
                  )}
                />
              )}
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default MonthGrid
